<template>
  <Section
    :breadCrumbs="breadCrumbs"
    @onClickBreadcrumb="(val) => $emit('onClickBreadcrumb', val)"
    v-bind="$attrs"
    :shouldShowSearch="shouldShowSearch"
    :title="title"
    icon="attachment"
    :toolbarActions="toolbarActions"
    @onClicked="(val) => $emit(val)"
    :isLoading="isLoading"
  >
    <template v-slot:toolbarExtension>
      <v-layout row wrap justify-space-between subheading>
        <v-flex shrink>
          <div>
            <v-icon>publish</v-icon>
            {{
              _formatJavascriptDate({ date: attachmentDetail.dateTimeUploaded })
            }}
          </div>
        </v-flex>
        <v-flex shrink text-xs-left text-sm-right>
          <div>
            <v-icon>face</v-icon>
            {{
              _entityPropertyValueByName({
                entityList: userList,
                idKey: "id",
                idValue: attachmentDetail.userIdUploadedBy,
                propertyKey: "name",
              })
            }}
          </div>
        </v-flex>
        <v-flex xs12 v-if="attachmentDetail.comments">
          <v-icon>comment</v-icon>
          {{ attachmentDetail.comments }}
        </v-flex>
      </v-layout>
    </template>
  </Section>
</template>

<script>
import mixinAssetHelper from '../../../../common/mixins/mixinAssetHelper'

import Section from '../../../../common/components/layouts/Section'
import SectionContainerPage from '../../../../common/components/layouts/SectionContainerPage'

export default {
  inheritAttrs: false,
  components: {
    Section,
    SectionContainerPage,
  },
  mixins: [mixinAssetHelper],
  props: {
    breadCrumbs: Array,
    title: String,
    toolbarActions: {
      model: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
    shouldShowSearch: {
      type: Boolean,
    },
    attachmentDetail: {
      type: Object,
      required: true,
    },
    modelList: {
      type: Array,
      required: true,
    },
    manufacturerList: {
      type: Array,
      required: true,
    },
    categoryList: {
      type: Array,
      required: true,
    },
    activityTypeList: {
      type: Array,
      required: true,
    },
    locationList: {
      type: Array,
      required: true,
    },
    clientList: {
      type: Array,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({}),
  computed: {},
  methods: {},
}
</script>
